import React from "react";

const KhatanoUtaro = () => {
  return (
    <div className="page-content">
      <div className="container-fluid">
        <h2>KhatanoUtaro</h2>
        <p>Content for KhatanoUtaro page will go here.</p>
      </div>
    </div>
  );
};

export default KhatanoUtaro;
